import {Injectable} from '@angular/core';
import {NzModalSubject} from "ng-zorro-antd";

@Injectable()
export class AttentionGroupService {

  public subject = new NzModalSubject();

  subject$=this.subject.asObservable();

  constructor() {
  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/attention-group.service.ts